@if (visible) {
  <div class="toast-notification" 
       [ngClass]="['toast-notification--' + type, 'toast-notification--' + position]"
       role="alert"
       aria-live="polite"
       aria-atomic="true">
    <div class="toast-notification__content">
      <div class="toast-notification__icon">
        <bcp-icon
          [name]="toastIcon"
          size="24"
          [color]="toastIconColor"
        ></bcp-icon>
      </div>
      
      <div class="toast-notification__text">
        @if (title) {
          <h4 class="toast-notification__title">{{ title }}</h4>
        }
        
        @if (message) {
          <p class="toast-notification__message">{{ message }}</p>
        }
      </div>
      
      @if (showCloseButton) {
        <button
          type="button"
          class="toast-notification__close"
          (click)="onDismiss()"
          (keyup)="$event.key === 'Enter' && onDismiss()"
          aria-label="Cerrar notificación"
          tabindex="0"
        >
          <bcp-icon
            name="close-b"
            size="20"
            color="neutral-700"
          ></bcp-icon>
        </button>
      }
    </div>
    
    @if (autoDismiss && duration > 0) {
      <div class="toast-notification__progress" 
           [style.animation-duration.ms]="duration"></div>
    }
  </div>
}
